import { render, staticRenderFns } from "./deposit-form.vue?vue&type=template&id=45b74188&"
import script from "./deposit-form.vue?vue&type=script&lang=js&"
export * from "./deposit-form.vue?vue&type=script&lang=js&"
import style0 from "./deposit-form.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports